import React, {SyntheticEvent, useState} from "react";
import {Tabs, Tab, Box} from "@mui/material";
import AppLayout from "../../../layouts/AdminLayout";
import AssignRiderModal from "./AssignRider";
import {PickupsTable} from "./PickupsTable";
import {UnassignedPickupsTable} from "./UnassignedPickup";
import {AssignedPickupsTable} from "./AssignedPickups";
import {FailedPickupsTable} from "./FailedPickup";
import {useRoles} from "../../../hooks/useRoles";

export default function Pickups() {
  const {scope} = useRoles();
  const [value, setValue] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [selectedPickups, setSelectedPickups] = useState<any[]>([]);

  const toggleOpen = () => setIsOpen(!isOpen);

  const handleChange = (event: SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const tabs = [
    {
      label: "All Pickups",
      value: "all",
      component: <PickupsTable />,
    },
    {
      label: "Unassigned Pickups",
      value: "unassigned",
      component: (
        <UnassignedPickupsTable
          selectedPickups={selectedPickups}
          setSelectedPickups={setSelectedPickups}
          hasSubmitted={hasSubmitted}
          setHasSubmitted={setHasSubmitted}
        />
      ),
    },
    {
      label: "Failed Pickups",
      value: "failed",
      component: (
        <FailedPickupsTable
          selectedPickups={selectedPickups}
          setSelectedPickups={setSelectedPickups}
          hasSubmitted={hasSubmitted}
          setHasSubmitted={setHasSubmitted}
        />
      ),
    },
    {
      label: "Assigned Pickups",
      value: "assigned",
      component: <AssignedPickupsTable />,
    },
  ];

  return (
    <AppLayout>
      <div className="flex items-center justify-between !py-10 !px-9">
        <div>
          <h3 className="!text-[28px] !font-bold !text-[#272835]">Pickups</h3>
          <p className="!text-sm !text-[#818898]">
            View and track all your pickup details below
          </p>
        </div>
        {value === 1 && scope === "write" && (
          <button
            className={`!text-sm !font-bold !text-white !h-12 !px-4 ${
              selectedPickups.length < 1 ? "bg-[#f27f1f]/20" : "bg-[#f27f1f]"
            }  rounded-[10px]`}
            disabled={selectedPickups.length < 1}
            onClick={toggleOpen}
          >
            Assign Pickups({selectedPickups.length})
          </button>
        )}
      </div>
      <AssignRiderModal
        closeModal={() => {
          setIsOpen(false);
        }}
        completeAssign={() => {
          setSelectedPickups([]);
          setIsOpen(false);
          setHasSubmitted(true);
        }}
        isOpen={isOpen}
        selectedPickups={selectedPickups}
        setSelectedPickups={setSelectedPickups}
      />
      <Box
        sx={{
          height: "100%",
          width: "92%",
          margin: "24px auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box sx={{borderBottom: 1, borderColor: "#E2E2E2"}}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              "& .MuiTabs-indicator": {
                backgroundColor: "#4B5563",
                height: 2,
              },
            }}
          >
            {tabs.map(({label}, index) => (
              <Tab
                key={index}
                label={label}
                sx={{
                  fontWeight: "bold",
                  fontSize: "1rem",
                  textTransform: "none",
                  color: value === index ? "#4B5563" : "#9CA3AF", // gray-700 and gray-400
                  minWidth: 0,
                  padding: "0 16px 12px",
                  marginRight: "16px",
                  "&.Mui-selected": {
                    color: "#4B5563",
                  },
                }}
              />
            ))}
          </Tabs>
        </Box>

        <Box sx={{mt: 3, flex: 1}}>
          {tabs.map(({component}, index) => (
            <div
              key={index}
              role="tabpanel"
              hidden={value !== index}
              id={`simple-tabpanel-${index}`}
              aria-labelledby={`simple-tab-${index}`}
            >
              {value === index && component}
            </div>
          ))}
        </Box>
      </Box>
    </AppLayout>
  );
}
